import { render, staticRenderFns } from "./CreateValidatorMessageDetails.vue?vue&type=template&id=7c476df2&"
import script from "./CreateValidatorMessageDetails.vue?vue&type=script&lang=js&"
export * from "./CreateValidatorMessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports